import { Expose, Type } from "class-transformer";
import { IsArray, IsBoolean, IsNumber, IsOptional, IsString, ValidateNested } from "class-validator";
import GenericTableResponse from "@/models/api/GenericTableResponse";

export class Airline {
  @IsNumber()
  @Expose()
  id!: number;

  @IsString()
  @Expose()
  @IsOptional()
  icaoCode!: string | null;

  @IsString()
  @Expose()
  @IsOptional()
  iataCode!: string | null;

  @IsString()
  @Expose()
  name!: string;

  @IsString()
  @Expose()
  @IsOptional()
  numericCode!: string | null;

  @IsBoolean()
  @Expose()
  @IsOptional()
  isLowCost!: boolean;

  @IsNumber()
  @Expose()
  recordStampId!: number;

  @IsString()
  @Expose()
  @IsOptional()
  contractorId!: string | null;

  @IsString()
  @Expose()
  @IsOptional()
  contractorName!: string;
}

export class AirlineResponse extends GenericTableResponse<Airline> {
  @Expose()
  @IsArray()
  @Type(() => Airline)
  @ValidateNested()
  // eslint-disable-next-line
  // @ts-ignore
  items!: Array<Airline>;
}
